import React, { ReactNode, useEffect } from "react"
import Icon from "components/elements/Icon"
import { Control, useForm, UseFormSetValue } from "react-hook-form"
import AutoSave from "./AutoSave"

export type SidePanelFormChildProps = {
  control: Control<any>
  setValue: UseFormSetValue<any>
}

type Props<T> = {
  onChange: (values: T) => void
  initialValues: any
  children: (props: SidePanelFormChildProps) => ReactNode
  onCancel?: (data: {}) => void
  selectedBlockId?: number
}

const SidePanelForm = <T, >({
  onChange, onCancel, initialValues, children, selectedBlockId,
}: Props<T>) => {
  const { control, reset, setValue } = useForm({
    defaultValues: initialValues,
    mode: "onChange",
  })

  useEffect(() => {
    reset(initialValues)
  }, [selectedBlockId, reset, initialValues])

  return (
    <form>
      <AutoSave control={control} onChange={onChange} />
      {onCancel && (
        <Icon
          icon="prev-arrow"
          onClick={onCancel}
          position="absolute"
          cursor="pointer"
          size={5}
          m={6}
        />
      )}
      {children({ control, setValue })}
    </form>
  )
}

export default SidePanelForm
